/*!
 * Vilya — Sold Out Detection Tracker (v2, privacy-first)
 * Détecte l'apparition de "Épuisé" / bouton disabled sur la page produit.
 * Ne collecte AUCUNE donnée personnelle. 1 event max par session.
 * Utilise sendBeacon pour survivre au close de page.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://webhook.site/29721191-9612-4921-99e6-225de9241bb5';

  var SOLD_OUT_STRINGS = [
    'epuise', 'sold out', 'soldout',
    'indisponible', 'unavailable', 'out of stock'
  ];

  var state = {
    logged: false,
    startedAt: Date.now(),
    triggerHistory: []
  };

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function detectSoldOut(btn) {
    if (!btn) return null;
    var raw = (btn.textContent || '').trim();
    var text = normalize(raw);
    var disabled = btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true';
    var matched = null;
    for (var i = 0; i < SOLD_OUT_STRINGS.length; i++) {
      if (text.indexOf(SOLD_OUT_STRINGS[i]) !== -1) { matched = SOLD_OUT_STRINGS[i]; break; }
    }
    return (disabled && matched) ? { matched: matched, rawText: raw.slice(0, 40) } : null;
  }

  function findButtons() {
    return document.querySelectorAll(
      '[id^="ProductSubmitButton-"], product-form button[type="submit"]'
    );
  }

  function getQueryParam(name) {
    try {
      var m = location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
      return m ? decodeURIComponent(m[1]).slice(0, 80) : null;
    } catch (e) { return null; }
  }

  function getDeviceType() {
    var w = window.innerWidth;
    if (w < 768) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }

  function getTrafficSource() {
    var utmSource = getQueryParam('utm_source');
    if (utmSource) return utmSource;
    if (getQueryParam('fbclid')) return 'facebook';
    if (getQueryParam('gclid')) return 'google-ads';
    if (getQueryParam('ttclid')) return 'tiktok';
    if (getQueryParam('msclkid')) return 'bing-ads';
    if (getQueryParam('srsltid')) return 'google-shopping';
    if (getQueryParam('_kx')) return 'klaviyo';
    var ref = document.referrer || '';
    try {
      if (ref) {
        var host = new URL(ref).hostname.replace(/^www\./, '');
        if (host === location.hostname) return 'internal';
        if (host.indexOf('google.') !== -1) return 'google-organic';
        if (host.indexOf('facebook.') !== -1 || host.indexOf('fb.') !== -1) return 'facebook-ref';
        if (host.indexOf('instagram.') !== -1) return 'instagram-ref';
        if (host.indexOf('tiktok.') !== -1) return 'tiktok-ref';
        if (host.indexOf('bing.') !== -1) return 'bing-organic';
        return 'other:' + host.slice(0, 50);
      }
    } catch (e) {}
    return 'direct';
  }

  function getFromCache() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (!nav) return null;
      return nav.type === 'back_forward' || (nav.transferSize === 0 && nav.decodedBodySize > 0);
    } catch (e) { return null; }
  }

  function getConnectionType() {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return c ? (c.effectiveType || null) : null;
    } catch (e) { return null; }
  }

  function getKachingPresent() {
    try {
      return !!document.querySelector('kaching-bundles-form, [class*="kaching-bundles"]');
    } catch (e) { return false; }
  }

  function getBrowserFamily() {
    var ua = navigator.userAgent || '';
    if (/FBAN|FBAV/.test(ua)) return 'facebook-webview';
    if (/Instagram/.test(ua)) return 'instagram-webview';
    if (/TikTok/.test(ua)) return 'tiktok-webview';
    if (/Line\//.test(ua)) return 'line-webview';
    if (/CriOS/.test(ua)) return 'chrome-ios';
    if (/Chrome/.test(ua) && !/Edg|OPR/.test(ua)) return 'chrome';
    if (/Firefox/.test(ua)) return 'firefox';
    if (/Edg/.test(ua)) return 'edge';
    if (/Safari/.test(ua) && !/Chrome/.test(ua)) return 'safari';
    if (/Samsung/.test(ua)) return 'samsung';
    return 'other';
  }

  function getOS() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPod/.test(ua)) return 'ios';
    if (/iPad/.test(ua)) return 'ipados';
    if (/Android/.test(ua)) return 'android';
    if (/Windows/.test(ua)) return 'windows';
    if (/Macintosh|Mac OS X/.test(ua)) return 'macos';
    if (/Linux/.test(ua)) return 'linux';
    return 'other';
  }

  function buildPayload(detection, trigger) {
    var now = Date.now();
    return {
      v: 2,
      ts: new Date().toISOString(),
      msSinceLoad: now - state.startedAt,
      trigger: trigger,
      triggerHistory: state.triggerHistory.slice(-10),
      handle: (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || null,
      variantId: getQueryParam('variant'),
      textFound: detection.matched,
      rawText: detection.rawText,
      device: getDeviceType(),
      os: getOS(),
      browser: getBrowserFamily(),
      connection: getConnectionType(),
      fromCache: getFromCache(),
      source: getTrafficSource(),
      kachingPresent: getKachingPresent(),
      viewport: { w: window.innerWidth, h: window.innerHeight, dpr: window.devicePixelRatio || 1 },
      lang: (navigator.language || '').slice(0, 10),
      readyState: document.readyState
    };
  }

  function send(payload) {
    try {
      var body = JSON.stringify(payload);
      // text/plain pour bypass CORS preflight (body JSON accepté par webhook.site quand même)
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body,
        keepalive: true,
        mode: 'no-cors',
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  function notifyClarity(payload) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'sold_out_detected');
        window.clarity('set', 'sold_out_trigger', String(payload.trigger || ''));
        window.clarity('set', 'sold_out_product', String(payload.handle || ''));
        window.clarity('set', 'sold_out_source', String(payload.source || ''));
        window.clarity('set', 'sold_out_browser', String(payload.browser || ''));
        window.clarity('set', 'sold_out_device', String(payload.device || ''));
        window.clarity('upgrade', 'sold-out-session');
      }
    } catch (e) {}
  }

  function check(trigger) {
    if (state.logged) return;
    state.triggerHistory.push(trigger);
    if (state.triggerHistory.length > 30) state.triggerHistory.splice(0, 10);
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var detection = detectSoldOut(buttons[i]);
      if (detection) {
        state.logged = true;
        var payload = buildPayload(detection, trigger);
        send(payload);
        notifyClarity(payload);
        return;
      }
    }
  }

  function init() {
    if (!/\/products\//.test(location.pathname)) return;
    check('initial');
    setTimeout(function () { check('t+300ms'); }, 300);
    setTimeout(function () { check('t+1s'); }, 1000);
    setTimeout(function () { check('t+3s'); }, 3000);
    setTimeout(function () { check('t+7s'); }, 7000);

    try {
      var mo = new MutationObserver(function () { check('mutation'); });
      var root = document.querySelector('main') || document.body;
      if (root) {
        mo.observe(root, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          subtree: true,
          childList: true,
          characterData: true
        });
      }
    } catch (e) {}

    document.addEventListener('change', function () {
      setTimeout(function () { check('variant-change'); }, 500);
    }, true);

    document.addEventListener('click', function () {
      setTimeout(function () { check('click'); }, 500);
    }, true);

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        state.logged = false;
        state.startedAt = Date.now();
        state.triggerHistory = [];
        check('bfcache');
      }
    });

    window.addEventListener('pagehide', function () { check('pagehide'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
